module.exports = __webpack_public_path__ + "img/success-bot.9221cd17.png";